<template>
  <div >
    <div style="margin:10px;">
      <el-row :gutter="20" type="flex" style="flex-wrap:wrap">
        <div class="select-info pt-5" v-if="mode!='tile'">
          <span v-if="selected.length==0 && !isFiltered" class="fs-14">{{$t('sales_orders.AllSalesOrders')}} <span><el-button icon="el-icon-plus" circle size="small" @click="$emit('new')"></el-button></span></span>
          <span v-else>
            <span class="fs-14">{{$t('left-menu.sales-orders')}}</span>
            <span v-if="selected.length==0 && isFiltered">
              <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> {{$t('common.SearchResults')}}</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{count}}</span>
            </span>
            <span v-else>
              <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> {{$t('sales_orders.Selected')}}</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{selected.length}}</span>
              <el-dropdown size="small" split-button type="primary" class="ml-20">
                {{$t('common.Actions')}}
                <el-dropdown-menu slot="dropdown">
                 <el-dropdown-item :disabled="true"><i class="mdi mdi-cancel"></i>{{$t('common.Cancel')}}</el-dropdown-item>
                 <el-dropdown-item @click.native="downloadCSVReport('csv')"><i class="mdi mdi-file-excel"></i>{{$t('common.ExportCSV')}}</el-dropdown-item>
                 <el-dropdown-item :disabled="!canInvoiceSelectedSalesOrder" @click.native="$emit('invoiceSelectedSalesOrder',selected)"><i class="mdi mdi-file-document"></i>{{$t('sales_orders.bill')}}</el-dropdown-item>
                 <el-dropdown-item :disabled="isDuplicateDisabled" @click.native="duplicate"><i class="mdi mdi-content-copy"></i>{{$t('sales_orders.duplicate')}}</el-dropdown-item>
                 <el-dropdown-item :disabled="true"><i class="di mdi-file-pdf-box"></i>{{ $t('sales_orders.downloadPDF') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </span>
        </div>
        <div class="search-box">
          <el-input
            :placeholder="$t('sales_orders.Search')"
            clearable
            v-model="search">
            <el-dropdown slot="append" style="border-right:1px;">
                <el-button type="primary">
                {{$t('common.sortBy')}}<i class="el-icon-sort el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :icon="sortIcon('customer.name')" @click.native="sortBy('customer.name')">{{$t('sales_orders.sorting.customer')}}</el-dropdown-item>
                <el-dropdown-item :icon="sortIcon('soNumber')" @click.native="sortBy('soNumber')">{{$t('sales_orders.sorting.salesOrdernumber')}}</el-dropdown-item>
                <el-dropdown-item  :icon="sortIcon('updated_at')" @click.native="sortBy('updated_at')">{{$t('sales_orders.sorting.lastUpdated')}}</el-dropdown-item>
                <el-dropdown-item  :icon="sortIcon('date')" @click.native="sortBy('date')">{{$t('sales_orders.sorting.salesDate')}}</el-dropdown-item>
                <el-dropdown-item  :icon="sortIcon('created_at')" @click.native="sortBy('created_at')">{{$t('sales_orders.sorting.createdDate')}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button slot="prepend" @click="showFilters=true"  class="text-left filter-button">
              <i class="mdi mdi-filter-variant" style="font-size:15px;">
                <span v-if="getNbFiltersCriteria>0">{{getNbFiltersCriteria}}
                  <span class="hidden-md-and-down">
                    <span v-if="getNbFiltersCriteria==1">{{$t('common.filter')}}</span>
                    <span v-else>{{$t('common.filters')}}</span>
                    <span v-if="getNbFiltersCriteria==1"> {{$t('common.applied')}}</span>
                    <span v-else> {{$t('common.applieds')}}</span>
                  </span>
                  <el-link type="info" @click="resetFilters" class="ml-2">
                    <i class="mdi mdi-filter-remove"/>
                  </el-link>
                </span>
                <span v-else class="secondary-text fs-14"> <span class="hidden-md-and-down">{{$t('common.advancedFilters')}}</span></span>
              </i>
            </el-button>
          </el-input>
        </div>
      </el-row>
    </div>
    <div class="flex center m-10">
      <Pagination
        class="box right mt-5 mb-0 fs-14 secondary-text"
        :current-page="page"
        :total-number-of-page="pages"
        @click-previous="fetchPreviousPage"
        @click-next="fetchNextPage" />
    </div>
    <div class="box grow scrollable only-y item-list no-p" :style="getHeightStyle" v-loading="loading" v-if="mode=='tile'">
      <div v-for="(so, index) in salesOrders" :key="so.id" class="flex item no-p"  :class="{ active : (selectedSalesOrder!=null && selectedSalesOrder.id == so.id) }" @click="selectSO(so,index)">
        <SalesOrderTile :customer="so.customer" :tags="so.tags" :shipping_contact="so.shipping_contact" :so_number="so.soNumber" :reference="so.reference" :date="so.date" :total="so.total" :status="so.status" :sales_rep="so.rep" :origin="so.origin" :positive="isPositive(so)" :negative="isNegative(so)" :intermediary="isIntermediary(so)" :lines="so.lines"></SalesOrderTile>
      </div>
    </div>
    <div v-else>
      <el-table
      :data="salesOrders"
      stripe
      v-loading="loading"
      :height="getHeight"
      :cell-style="{padding:'3px'}"
      :empty-text="$t('sales_orders.no_sales_orders')"
      @selection-change="handleSelectionChange"
      style="width: 100%">
      <el-table-column
        type="selection"
        width="50">
      </el-table-column>
      <el-table-column
        prop="id"
        fixed
        text-align="center"
        width="60">
        <template slot-scope="scope">
           <span v-if="isB2B(scope.row)" class="ml-5 fs-14 secondary-text">
              <el-image src="/logo-panorama.png" style="height:16px;"></el-image>
            </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="soNumber"
        :label="$t('sales_orders.soNumber')"
        width="180">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.id" path="/sales-orders/" :label="scope.row.soNumber"></PortausLink>
          <i v-if="!qtyValid(scope.row.lines)" class="mdi mdi-alert ml-5">&nbsp;</i>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        :label="$t('common.date')"
        width="120">
        <template slot-scope="scope">
          <span>{{moment(scope.row.date, 'L')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('sales_orders.deliveryDate')"
        prop="expectedDeliveryDate"
        width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.expectedDeliveryDate!= null">{{moment(scope.row.expectedDeliveryDate, 'L')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="customer.name"
        :show-overflow-tooltip="true"
        :label="$t('clients.name')">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.customer.id" path="/customers/" :label="customerName(scope.row.customer.name, scope.row.customer.usualName)"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column
        prop="balance.outstanding"
        :show-overflow-tooltip="true"
        align="center"
        :label="$t('sales_orders.total')"
        width="150">
        <template slot-scope="scope">
          <span>{{$n(scope.row.total,'currency')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status.code"
        :label="$t('sales_orders.status')"
        align="center"
        width="190"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <SalesOrderStatusTag :status="scope.row.status" />
        </template>
      </el-table-column>
      
    </el-table>
    </div>
    <SalesOrderFilter :visible="showFilters" direction="ltr" @close="showFilters=false"></SalesOrderFilter>
  </div>
</template>
<script>
  import SalesOrderTile from '@/components/salesOrder/Sales-order-tile'
  import { mapActions, mapState, mapGetters } from 'vuex';
  import SalesOrderFilter from './sales-order-filter'
  import moment from 'moment-timezone'
  import PortausLink from '@/components/portaus-link'
  import salesAPI from '@/services/API/sales'
  import customerUtils from '@/utils/customer-util.js'
  import SalesUtils from '@/utils/sales-utils'
  import Pagination from '@/components/pagination'
  import SalesOrderStatusTag from '@/views/pages/salesOrder/components/sales-order-status-tag'

  export default {
    name: 'Sales-Orders-List',
    props: {

  	},
    data() {
      return {
        selected : [],
        showFilters:false,
        index : null,
        active_el : null,
        window: {
          width: 0,
          height: 0
        }
      };
    },components: {
      SalesOrderTile,
      SalesOrderFilter,
      PortausLink,
      Pagination,
      SalesOrderStatusTag
    },
    watch : {

    },
  	methods: {
      isB2B(salesOrder) {
        return _.get(salesOrder, 'origin') === 'B2B';
      },
      duplicate () {
        this.$emit('duplicate', this.selected[0]);
      },
      qtyValid(lines){
        let valid = true;
        if (_.isEmpty(lines)) return valid;
        _.forEach(lines, l => {
          if (l.quantityAvailable === false) valid = false;
        })
        return valid;
      },
      downloadCSVReport(format){
        this.downloading=true;
        let params = {id:[]};
        params.id = _.map(this.selected, 'id');
        params.format=format;
        // let params = _.cloneDeep(this.fetchParams);
        // params.format='csv';
        // delete params.limit;
        // params.customerClassId = params.customerClasses;
        // delete params.customerClasses;

        return salesAPI.downloadTransactionSalesReport(params,'sales_orders.csv')
          .then(()=>{
            this.downloading=false;
          }).catch(err=>{
            console.log(err);
            this.downloading=false;
            this.$message.error("Oops... Une erreur est survenue!");
          })
      },
      handleSelectionChange(val){
        this.selected = val;
      },

      formatAmount(amount){
        return parseFloat(amount).toFixed(2);
      },
      calculatePOTotalAmount(so){
        return so.total_amount_items+so.adjustment;
      },
      sortBy(orderName){

        if(this.orderBy.orderName!=orderName){
          this.orderBy={orderName : orderName, direction:'DESC'};
          this.sort_icon = this.icons['ASC'];
        }else{
          if(this.orderBy.direction=='DESC'){
            this.orderBy={orderName : orderName, direction:'ASC'};
            this.sort_icon = this.icons['ASC'];
          }else{
            this.orderBy={orderName : orderName, direction:'DESC'};
            this.sort_icon = this.icons['DESC'];
          }
        }
      },
      sortIcon(orderName){
        return orderName==this.orderBy.orderName?this.sort_icon:'';

      },
      selectSO(so,index){
        this.$emit('select',so,index);
      },
      moment(datetime, format='LL'){
  			return  moment(datetime).format(format);
  		},
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      customerName (name, usualName) {
        return customerUtils.customerName(name, usualName);
      },
      isPositive(so) {
        return SalesUtils.isPositive(so);
      },
      isNegative(so) {
        return SalesUtils.isNegative(so);
      },
      isIntermediary(so) {
        return SalesUtils.isIntermediary(so);
      },
      ...mapActions('salesOrders', ['fetchPreviousPage', 'fetchNextPage','setSearchTerms','changeOrderBy','changeSortIcon','changePage','resetFilters']),
      ...mapGetters('salesOrders', ['getOrderBy', 'getSortIcon','selectedSalesOrderTagType'])

  	},
  	computed: {
      isDuplicateDisabled () {
        return this.selected.length !== 1;
      },
      canInvoiceSelectedSalesOrder(){
        let canInvoiceSelectedSalesOrder = true;
        if (!this.isInvoiceMultipleSalesOrderEnable) canInvoiceSelectedSalesOrder = false;
        if(this.selected.length==0) return false;
        _.forEach(this.selected, s=>{
          _.forEach(s.invoices, i => {
            if(i.status.code!= 'VOIDED'){
              canInvoiceSelectedSalesOrder = false;
            }
          })
        })
        return canInvoiceSelectedSalesOrder
      },
      orderBy : {
  			set(val){this.changeOrderBy(val)},
  			get(){return this.getOrderBy()}
  		},sort_icon : {
  			set(val){this.changeSortIcon(val)},
  			get(){return this.getSortIcon()}
  		},
      search : {
          set(val){ this.setSearchTerms(val)},
          get(){return this.searchTerms}
      },
      getHeight(){
  			return (this.window.height-300);
  		},
      getHeightStyle(){
        return "height:" + (this.window.height-242) + "px;";
      },
      ...mapState('salesOrders', ['searchTerms','loading','selectedSalesOrder','icons', 'salesOrders','page','pages','limit', 'count','mode']),
      ...mapGetters('salesOrders',['totalAmountByIndex','getNbFiltersCriteria','isFiltered','fetchParams','isInvoiceMultipleSalesOrderEnable'])
  	},
    mounted(){

    },
  	created(){
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.select-info{
  flex: 0 0 360px;
}

.search-box{
  flex: 1;
}

.filter-button{
  min-width:180px;
}

  .active{
    background-color: lighten($background-color, 20%);
    border-radius: 5px;
    box-shadow:none;
    box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
  }


  .item-list {
    //margin: 0 auto;
    width: 100%;
    // padding: 0px 30px;
    box-sizing: border-box;

    .item {
      margin: 10px 0;
      padding: 5px;
      box-sizing: border-box;
      cursor: pointer;
      transition: all .5s .25s;


      .info {
        word-break: break-word;

      }

      &:hover {
        //margin: 15px -20px;
        //padding: 10px;
        background-color: lighten($background-color, 20%);
        border-radius: 5px;
        box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

      }

    }
  }
  @media (max-width: 1024px) {
    .filter-button{
      min-width:30px;
    }

    .search-box{
      flex: 1 100%;
    }


    .select-info{
      flex: 1 100%;
      margin-bottom:10px;
      height:30px;
    }
  }

  </style>
